const ANSWER_ONE = 'Menos de $65.891.000 (equivalentes a 1.400 UVT)';
const ANSWER_TWO =
  'Igual o más de $65.891.000 pero menos de $164.727.500 (equivalente a igual o más de 1.400 UVT pero menos de 3.500 UVT)';
const ANSWER_THREE = 'Igual o más de $164.727.500 (equivalente a 3.500 UVT)';
const ANSWER_FOUR = 'Más de $1.411.950.000 (equivalente a más de 30.000 UVT)';
const ANSWER_FIVE =
  'Igual o menos de $ 211.792.500 (equivalente a igual o menos de 4.500 UVT)';
const ANSWER_SIX = 'Más de $211.792.500 (equivalente a más de 4.500 UVT)';
const ANSWER_SEVEN = 'Más de $1.411.950.000 (equivalente a más de 30.000 UVT)';

export {
  ANSWER_ONE,
  ANSWER_TWO,
  ANSWER_THREE,
  ANSWER_FOUR,
  ANSWER_FIVE,
  ANSWER_SIX,
  ANSWER_SEVEN,
};
